import React from 'react';
import QuotationBuilder from '../../QuotationBuilder';

const PrivateCarInsurance = () => {
  // Use the existing QuotationBuilder component for Private Car
  return <QuotationBuilder />;
};

export default PrivateCarInsurance;

